import ChevronRght from '#/assets/images/icons/chevron-right.svg'
import SvgLogo from '#/assets/images/logos/app-icon.svg'
import Link from '#/components/Link'

interface BreadCrumbsProps {
  pageName: string
  homeName: string
  categoryName?: string
  endpoint?: string
  additional?: string
}

export default function BreadCrumbs({
  pageName,
  homeName,
  categoryName,
  endpoint,
  additional
}: BreadCrumbsProps) {
  return (
    <nav aria-label='Breadcrumb' className='flex'>
      <ol className='flex items-center space-x-3'>
        <li>
          <div className='flex items-center'>
            <Link
              className='flex items-center text-gray-400 hover:text-gray-500'
              href='/'
            >
              <SvgLogo className='th-icon' />
              <span className='sr-only'>Home</span>
            </Link>
            <Link
              className='pl-3 text-xs font-medium text-gray-400 hover:text-gray-700'
              href='/'
            >
              {homeName || 'Home'}
            </Link>
          </div>
        </li>
        {pageName && (
          <li>
            <div className='flex items-center'>
              <ChevronRght className='h-2 w-2 shrink-0 text-gray-400' />
              <Link
                aria-current='page'
                className='truncate pl-2 text-xs font-medium text-gray-400 hover:text-gray-700 xs:w-full sm:w-full'
                href={endpoint || `/${pageName.toLowerCase()}`}
              >
                {pageName}
                {' '}
                {additional}
              </Link>
            </div>
          </li>
        )}
        {categoryName && (
          <li>
            <div className='flex items-center'>
              <ChevronRght className='h-2 w-2 shrink-0 text-gray-400' />
              <div
                aria-current='page'
                className='w-32 cursor-pointer truncate pl-2 text-xs font-medium capitalize text-gray-400 hover:text-gray-700 sm:w-64'
              >
                {categoryName}
              </div>
            </div>
          </li>
        )}
      </ol>
    </nav>
  )
}
